import type { ConsumptionType } from './types';

export const SELECTION_NAME_MAX = 30;
export const CONSUMPTION_TYPES: ConsumptionType[] = ['Chaud', 'Froid'];

/** « Réseau concerné » : libellé production `${networkIdentifier} ${networkName}` — réseaux fictifs. */
export const HEAT_NETWORK_OPTIONS: { value: string; label: string }[] = [
  { value: 'net-9228', label: '9228C Réseau de chaleur de Sèvres' },
  { value: 'net-9248', label: '9248C Meudon-sur-Seine' },
  { value: 'net-9212', label: '9212C Boulogne-Billancourt Trapèze' },
  { value: 'net-9264', label: '9264C Saint-Cloud Centre' },
  { value: 'net-9240', label: '9240C Issy-les-Moulineaux' },
  { value: 'net-9206', label: '9206F Réseau de froid La Défense' },
];

// Palette copiée de ColorPicker.ts (production) : couleurs d'identification sur la carte.
export const SELECTION_COLORS = [
  '#D90900', '#B600B4', '#FF016C', '#EF6400', '#FFCC00', '#4FB400', '#007A79', '#00A6DA', '#0046AF', '#6E14BF',
];
export const SELECTION_COLORS_EXTENDED = [
  ...SELECTION_COLORS,
  '#FF2F26', '#ED00EB', '#FF3F8F', '#FF8D29', '#FFE249', '#90C022', '#00B0AF', '#00C2FF', '#0076C6', '#A036FF',
  '#FF635C', '#FF4FFE', '#FF87B9', '#FFAC63', '#FFEF99', '#BAF175', '#8AE2E2', '#9DE8FF', '#0098FF', '#C27DFF',
  '#A00700', '#9B009A', '#CB0055', '#BB4300', '#C19B00', '#007405', '#006362', '#006C8E', '#00327C', '#552382',
  '#6B0500', '#6A006A', '#800036', '#883900', '#947C00', '#005304', '#003E3A', '#00455A', '#002864', '#280047',
];

/** Production : couleur tirée au hasard dans la palette étendue à l'ouverture du formulaire. */
export const randomSelectionColor = () =>
  SELECTION_COLORS_EXTENDED[Math.floor(Math.random() * SELECTION_COLORS_EXTENDED.length)];
